/* settings.svelte.ts generated by Svelte v5.55.3 */
import * as $ from 'svelte/internal/client';
import { db } from "../db";

let settings = $.state($.proxy({
	id: "default",
	theme: "light",
	units: "metric",
	showHealthReferenceRanges: true,
	showGoals: true,
	feedAlertThresholdMs: 3 * 60 * 60 * 1000,
	syncEnabled: false,
	notificationsEnabled: false
}));

let systemThemeWatcherAttached = false;

function resolveTheme(theme) {
	if (theme === "system") {
		return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
	}

	return theme;
}

export function applyTheme(theme = $.get(settings).theme) {
	document.documentElement.setAttribute("data-theme", resolveTheme(theme));
}

export function watchSystemTheme() {
	if (systemThemeWatcherAttached) return;

	const media = window.matchMedia("(prefers-color-scheme: dark)");

	const handleChange = () => {
		if ($.get(settings).theme === "system") applyTheme("system");
	};

	media.addEventListener("change", handleChange);
	systemThemeWatcherAttached = true;
}

export function getSettings() {
	return $.get(settings);
}

export async function loadSettings() {
	const saved = await db.settings.get("default");

	if (saved) $.set(settings, saved, true);

	applyTheme($.get(settings).theme);
	watchSystemTheme();
}

export async function updateSettings(updates) {
	$.set(settings, { ...$.get(settings), ...updates }, true);
	await db.settings.put(JSON.parse(JSON.stringify($.get(settings))));

	if (updates.theme) {
		applyTheme($.get(settings).theme);
	}
}